<template>
  <div class="report-full-screen">
    <report-runtime :id="reportId"></report-runtime>
  </div>
</template>

<script>
import ReportRuntime from './report-runtime.vue'
export default {
  name: 'ReportFullScreen',
  data () {
    return {
      reportId: this.$route.query.id,
      title: this.$route.query.title
    }
  },
  mounted () {
    document.title = this.title
  },
  components: {
    ReportRuntime
  }
}
</script>
<style lang="scss" >
.report-full-screen {
  height: 100%;
 /* 自定义报表的滚动条触摸展示*/
  ::-webkit-scrollbar-thumb{
    background-color: transparent;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/report/runtime/report-full-screen.vue